const assistanceBtn = document.querySelector('.assistance.mobile-menu__block');
assistanceBtn.addEventListener('click', () => {
  const drawerContent = document.querySelector('.sliderule__assistance');
  // document.querySelectorAll('.sliderule__wrapper').forEach((el) => {
  //   el.classList.toggle('hide');  
  // })
  if(assistanceBtn.classList.contains('open')) {
  } else {
      drawerContent.querySelector('button.sliderow').click(); 
      assistanceBtn.classList.add('open')
  }
  // drawerContent.style.display = 'block';
  // drawerContent.querySelector('.sliderow__back-button').addEventListener('click',  () => {
  //   drawerContent.style.display = 'none';
  // })
})

const backBtn = document.querySelector('.sliderule__assistance .sliderow__back-button')?.addEventListener('click', () => {
  assistanceBtn.classList.remove('open')
})